/**
 * Detection + copy for Next.js server-action version skew.
 *
 * After a production deploy, a stale browser tab that invokes a server action
 * gets rejected because the action id from the old bundle no longer exists on
 * the new deployment. Vercel Skew Protection caps at 12h on Pro, so long-lived
 * tabs still hit this. Next.js surfaces it as a client-side rejection whose
 * message is stable across versions (see
 * https://nextjs.org/docs/messages/failed-to-find-server-action).
 *
 * Pure module on purpose: testable under node-env vitest, safe to import
 * anywhere.
 */

export const VERSION_SKEW_TOAST_TITLE = 'Kehilla was just updated'
export const VERSION_SKEW_TOAST_DESCRIPTION = 'Refresh this page to continue.'
export const VERSION_SKEW_REFRESH_LABEL = 'Refresh'

const SKEW_PATTERNS = [
  // Next 15 wording
  /failed to find server action/i,
  // Next 16 wording
  /server action ["'][^"']*["'] was not found/i,
  // Shared trailer, in case the lead sentence changes again
  /older or newer deployment/i,
]

export function isVersionSkewError(error: unknown): boolean {
  const message =
    typeof error === 'string'
      ? error
      : error !== null &&
          typeof error === 'object' &&
          'message' in error &&
          typeof (error as { message: unknown }).message === 'string'
        ? (error as { message: string }).message
        : ''
  return SKEW_PATTERNS.some((pattern) => pattern.test(message))
}
